export const removeUserRestrictionById = (array, userId, restriction) => {
    return array?.map((item) => {
        if (item.user.id === userId) {
            item.user.restrictions = item.user.restrictions.filter(item => item !== restriction)
        }
        return item
    })
}